(() => {
  const ready = (fn) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn)
    : fn();

  ready(() => {
    const header = document.querySelector('[data-muga-header]');
    const setHeader = () => {
      if (!header) return;
      header.classList.toggle('is-solid', window.scrollY > 24 || header.dataset.transparent !== 'true');
    };
    setHeader();
    window.addEventListener('scroll', setHeader, { passive: true });

    const menu = document.querySelector('[data-muga-mobile-menu]');
    const openMenu = () => {
      if (!menu) return;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('muga-menu-open');
    };
    const closeMenu = () => {
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('muga-menu-open');
    };
    document.querySelectorAll('[data-muga-menu-open]').forEach(el => el.addEventListener('click', openMenu));
    document.querySelectorAll('[data-muga-menu-close], [data-muga-mobile-menu] a').forEach(el => el.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });

    document.querySelectorAll('[data-muga-form]').forEach((form) => {
      const select = form.querySelector('[data-muga-state]');
      const tags = form.querySelector('[data-muga-tags]');
      const params = new URLSearchParams(window.location.search);
      const requested = (params.get('state') || '').toLowerCase();
      if (select && requested) {
        const option = [...select.options].find(item => item.value.toLowerCase() === requested);
        if (option) select.value = option.value;
      }
      const updateTags = () => {
        if (!tags) return;
        const source = form.dataset.source || 'MUGA Website';
        tags.value = `MUGA Early Access, ${source}, State: ${select?.value || 'All Three'}`;
      };
      select?.addEventListener('change', updateTags);
      updateTags();
    });

    const items = document.querySelectorAll('[data-muga-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      items.forEach(item => observer.observe(item));
    } else {
      items.forEach(item => item.classList.add('is-visible'));
    }
  });
})();

(() => {
  if (document.getElementById('muga-heading-scale-50')) return;
  const style = document.createElement('style');
  style.id = 'muga-heading-scale-50';
  style.textContent = `
    .muga-page-hero__content h1{font-size:clamp(23.5px,3.5vw,44px)!important}
    .muga-journal__head h1{font-size:32.5px!important}
    .muga-article__header h1{font-size:clamp(26px,4vw,48px)!important}
    .muga-mobile-menu__links a{font-size:18px!important}
  `;
  document.head.appendChild(style);
})();

(() => {
  if (document.getElementById('muga-principle-icon-center')) return;
  const style = document.createElement('style');
  style.id = 'muga-principle-icon-center';
  style.textContent = `
    .muga-principle__icon svg{display:block;margin-inline:auto!important}
  `;
  document.head.appendChild(style);
})();

(() => {
  if (document.getElementById('muga-state-product-portrait')) return;
  const style = document.createElement('style');
  style.id = 'muga-state-product-portrait';
  style.textContent = `
    .muga-state-detail__visual{
      aspect-ratio:3/4;
      min-height:0!important;
      background:#17110d;
      overflow:hidden;
    }
    .muga-state-detail__visual img{
      width:100%;
      height:100%;
      object-fit:cover;
      object-position:center;
      filter:none!important;
    }
    @media(min-width:861px){
      .muga-state-detail__grid{
        grid-template-columns:minmax(360px,.82fr) minmax(0,1.18fr)!important;
        min-height:0!important;
        align-items:stretch;
        overflow:hidden;
      }
      .muga-state-detail__visual,
      .muga-state-detail__content{
        min-width:0;
        width:100%;
      }
      .muga-state-detail__content{
        position:relative;
        z-index:1;
      }
    }
    @media(max-width:860px){
      .muga-state-detail__grid{grid-template-columns:1fr!important}
      .muga-state-detail__visual{aspect-ratio:3/4;min-height:0!important}
    }
  `;
  document.head.appendChild(style);
})();

(() => {
  if (document.getElementById('muga-hide-cart-links')) return;
  const style = document.createElement('style');
  style.id = 'muga-hide-cart-links';
  style.textContent = `
    .muga-header a[href="/cart"],
    .muga-header a[href$="/cart"],
    .muga-mobile-menu a[href="/cart"],
    .muga-mobile-menu a[href$="/cart"]{
      display:none!important;
    }
  `;
  document.head.appendChild(style);
})();

(() => {
  if (document.getElementById('muga-editorial-copy-refinement')) return;

  const main = document.querySelector('main[data-template]');
  if (!main) return;

  const storyTitle = document.querySelector('.muga-article__header h1')?.textContent.trim();
  if (storyTitle === 'The Beginning of Something Timeless') {
    document.documentElement.classList.add('muga-brand-story-page');
  }

  const style = document.createElement('style');
  style.id = 'muga-editorial-copy-refinement';
  style.textContent = `
    main[data-template="page.philosophy"] .muga-page-hero__content .muga-copy,
    main[data-template="page.the-states"] .muga-page-hero__content .muga-copy,
    main[data-template="page.the-house"] .muga-page-hero__content .muga-copy{
      max-width:44ch;
      font-family:var(--muga-serif)!important;
      font-size:12px!important;
      font-weight:400!important;
      line-height:1.55!important;
      letter-spacing:.015em;
      color:rgba(250,247,241,.84)!important;
    }

    html.muga-brand-story-page .muga-article__body{
      font-family:var(--muga-serif)!important;
      font-size:18.4px!important;
      font-weight:400!important;
      line-height:1.75!important;
      letter-spacing:.008em;
    }

    @media(max-width:560px){
      html.muga-brand-story-page .muga-article__body{
        font-size:16px!important;
        line-height:1.72!important;
      }
    }
  `;
  document.head.appendChild(style);
})();
